// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"9204f404","380":"30d36d1b","453":"7c475c72","559":"dcc7e059","629":"d9aaf246","637":"194dbf72","640":"7bc0768e","767":"f1131931","873":"3c024d35"}[chunkId] + ".chunk.js";
};